import { render } from "./OdorForm.vue?vue&type=template&id=11dc6136&scoped=true"
import script from "./OdorForm.vue?vue&type=script&lang=js"
export * from "./OdorForm.vue?vue&type=script&lang=js"

import "./OdorForm.vue?vue&type=style&index=0&id=11dc6136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dc6136"]])

export default __exports__